import React, {
  HTMLProps, forwardRef, ReactNode, CSSProperties,
} from 'react';

import { IMediaImage } from 'interfaces/media';
import Picture from 'UI/Picture/Picture';

type IImageElementProps = Omit<HTMLProps<HTMLPictureElement>, 'id'>;
interface IImageElement extends IImageElementProps {
  htmlId?: string;
}

interface IGatsbyPicture extends IImageElement, IMediaImage {
  className?: string;
  children?: ReactNode;
  css?: CSSProperties;
}

const GatsbyPicture = forwardRef<HTMLPictureElement, IGatsbyPicture>(({
  localFile,
  htmlId,
  alternativeText,
  className = '',
  children,
  style,
}, ref) => {
  const imageData = localFile?.childImageSharp?.gatsbyImageData;
  if (!imageData) return null;

  const { images: { fallback, sources }, width, height } = imageData;

  return (
    <Picture
      src={fallback.src}
      srcSet={fallback.srcSet}
      sizes={fallback.sizes}
      alt={alternativeText}
      sources={sources}
      style={style}
      id={htmlId}
      className={className}
      ref={ref}
      width={`${width}px`}
      height={`${height}px`}
    >
      {children}
    </Picture>
  );
});

export default GatsbyPicture;
